module.exports = __webpack_public_path__ + "img/location.f2f9c4ab.svg";